/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import {
  IAgentPlugin,
  IPluginMethodMap,
} from '@vlinder-web/plugin-agent-service-react';
import { signUpUserConfig } from '../../config/signUpUser.config';
import axios from 'axios';
import { apiConfig } from '@/config/apiConfig';

export interface SignUpUserProps {
  email: string;
  firstName: string;
  lastName: string;
  password?: string;
  phoneNumber?: string;
  jwtToken?: string;
  role?: string;
  headers: any;
  trn: any;
  optionSelected: any;
}

export interface ISignUpUserMethods extends IPluginMethodMap {
  signUpUser(args: any): Promise<any>;
}

export class SignUpUserService implements IAgentPlugin {
  readonly methods: ISignUpUserMethods;

  constructor() {
    this.methods = {
      signUpUser: this.signUpUser.bind(this),
    };
  }

  async signUpUser(args: SignUpUserProps) {
    const data = { ...args };
    delete data?.optionSelected;
    console.log(
      `signUpUser service:`,
      args,
      args?.optionSelected != 'roe' ? 'BUSSINESS_ORG' : 'CARICOM_BUSSINESS_ORG'
    );
    try {
      const res = await axios.post(
        `${apiConfig?.rest?.url}${signUpUserConfig?.singUpEP}`,
        {
          ...data,
          orgRole:
            args?.optionSelected != 'roe'
              ? 'BUSSINESS_ORG'
              : 'CARICOM_BUSSINESS_ORG',
        },
        {
          headers: {
            ...args?.headers,
          },
        }
      );
      if (res?.data) {
        console.log(`user res?.data`, res?.data);
        return res?.data;
      }
      // return true;
    } catch (err: any) {
      console.log(`signUp user error`, err?.response?.data);
      throw Error(err?.response?.data?.error?.display_message);
    }
  }
}
